import Button from '@viking-eng/button';
import { useNavigate } from 'react-router';

import './PageNotFound.scss';
import { APP_PAGES } from 'common/Constants';

const PageNotFound = () => {
  const navigate = useNavigate();
  return (
    <div className="not-found d-flex align-items-center justify-content-center" id="not-found">
      <div>
        <div className="d-flex justify-content-center mb-2 mt-5">
          <span role="none">
            <img
              alt="logo"
              className="viking-logo"
              src="https://aem-prod-publish.viking.com/content/dam/vikingcruises/en/magnolia-images/logo/VIKING_COLOR.svg"
            />
          </span>
        </div>
        <h2 className="d-flex justify-content-center font-weight-bold mb-2">
          <span>Page Not Found</span>
        </h2>
        <div className="d-flex justify-content-center align-items-center mb-2">
          <div className="row no-gutters">
            <div className="msg-text col-12">The page you have encountered is not available.</div>
            <div className="msg-text col-12">Please try another link or navigate to home.</div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <Button
            appearance="secondary-blue"
            className="m-4 text-uppercase"
            onButtonClick={() => navigate(APP_PAGES.INDEX.path)}
          >
            Back Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
